<template>
  <div class="dynamic-page-wrapper">
    <h1 v-if="showDisplayTitle" class="page-header">
      {{ pageTitle }}
    </h1>
    <div class="page-dynamic-content flex-col">
      <PageSection v-for="(section, index) in sections" :key="`${index}-section`" :section="section" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { QueryTypes } from '~/server/utils/contentstack';
import { contentstackRequest } from '~/util/contentstack/api';
import { metaGen } from '~/util/metadata';
import { getFirstIndex } from '~/util/arrays';
import { removePhpExtension } from '~/util/string';
import { useRootStore } from '~/store';

const { $bus }: any = useNuxtApp();
const route = useRoute();
const rootStore = useRootStore();
const { locale } = useI18n();
const event = useRequestEvent();

// check for .php extension
const fullPath = route.fullPath as string;
if (fullPath.includes('.php')) {
  const updatedUrl = removePhpExtension(fullPath);
  await navigateTo(updatedUrl);
}

const { data: asyncData, error: asyncError } = await useAsyncData(async () => {
  const params = route?.params;
  const contentStackData = await contentstackRequest(QueryTypes.page, `/${params.page}`, {
    event,
    query: {
      locale: locale?.value,
    },
  });
  // console.log('cts data', contentStackData)
  if (!contentStackData) throw createError({ statusCode: 404, message: 'Page not found' });

  const page = getFirstIndex(contentStackData?.data?.all_page?.items);
  if (!page) throw createError({ statusCode: 404, message: 'Page not found' });
  return {
    contentStackData,
    page,
  };
});

useAsyncErrorHandling({
  error: asyncError.value,
  consoleWanted: false,
});

useHead({
  ...(metaGen(rootStore?.brandSettings, {
    ...(asyncData.value?.page?.seo || {}),
  }) as any),
});

onMounted(() => {
  $bus.emit('pageView', {
    url: document.URL,
  });
});

const sections = computed(() => asyncData?.value?.page?.sections || []);
const pageTitle = computed(() => asyncData?.value?.page?.display_title || '');
const showDisplayTitle = computed(() => {
  if (asyncData?.value?.page?.show_display_title === undefined || asyncData?.value?.page?.show_display_title === null)
    return true;
  return asyncData?.value?.page?.show_display_title;
});
</script>
